module.exports = __webpack_public_path__ + "src/assets/img/guestlist_double_ma3.4d9ac462.jpg";